import * as Sentry from '@sentry/react';
// Reference to supported sentry log level
// @docs https://docs.sentry.io/platforms/javascript/enriching-events/level/
export enum LogLevel {
    DEBUG = 'debug',
    INFO = 'info',
    LOG = 'log',
    WARNING = 'warning',
    ERROR = 'error',
    FATAL = 'fatal',
}
type SeverityLevel = LogLevel.FATAL | LogLevel.ERROR | LogLevel.WARNING | LogLevel.INFO | LogLevel.LOG | LogLevel.DEBUG;
const debugLog = (level: SeverityLevel = LogLevel.DEBUG, message: string, context: any = {}) => {
    if (process.env.NODE_ENV === "development") {
        console.log({
            level,
            message,
            context,
        });
    } else {
        // Send to sentry but only important log
        if (level === LogLevel.WARNING || level === LogLevel.ERROR || level === LogLevel.FATAL) {
            // Send to Sentry
            try {
                // Send the log to Sentry as a message
                Sentry.setContext("context", context);
                Sentry.captureMessage(message, level);
            } catch (error) {
                console.error('Error sending log to Sentry:', error);
            }
        } else {
            // Hide log in prod for now
            // console.log({
            //     level,
            //     message,
            //     context,
            // });
        }
    }
};
export default debugLog;